module.exports = __webpack_public_path__ + "images/75625f7c67beb9b64229f57ddd7202d2.svg";